import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "text-primary",
  href: "#"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "→", -1)
const _hoisted_4 = {
  key: 3,
  class: "text-primary",
  href: "#"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  class: "text-primary",
  href: "#"
}
const _hoisted_7 = {
  class: "text-primary",
  href: "#"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_parent_insert = _resolveComponent("form-parent-insert")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_form_header = _resolveComponent("form-header")!
  const _component_form_travel = _resolveComponent("form-travel")!
  const _component_form_parent_activity = _resolveComponent("form-parent-activity")!
  const _component_q_timeline_entry = _resolveComponent("q-timeline-entry")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isLocked)
      ? (_openBlock(), _createBlock(_component_q_dialog, {
          key: 0,
          modelValue: _ctx.modalInsert,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalInsert) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card, {
              style: {"min-width":"280px"},
              class: "q-pa-md"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_form_parent_insert, { "insert-data": _ctx.parentTimer }, null, 8, ["insert-data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_timeline_entry, {
      ref: "el",
      title: _ctx.text ? `${_ctx.elapsedTime} ${_ctx.labelActivity(_ctx.parentTimer.type)}` : undefined,
      color: _ctx.color,
      icon: _ctx.icon,
      "data-unknown": _ctx.parentTimer.type === 'unknown' ? _ctx.index : false,
      "data-known": _ctx.parentTimer.type !== 'unknown' ? _ctx.index : false,
      "render-index": _ctx.index
    }, _createSlots({
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.parentTimer.type === 'travel')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.parentTimer.data.odometer_end)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.parentTimer.data.odometer_end - _ctx.parentTimer.data.odometer_start) + " " + _toDisplayString(_ctx.timelineLabel(_ctx.user.distance.value)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, [
                  (_ctx.parentTimer.data.departing === 'store')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "text-primary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push(`/stores/${_ctx.parentTimer.data.departingStoreId}`)))
                      }, _toDisplayString(`${_ctx.parentTimer.data.departingStoreName} #${_ctx.parentTimer.data.departingStoreNumber}`), 1))
                    : (_openBlock(), _createElementBlock("a", _hoisted_2, _toDisplayString(_ctx.formOptions(_ctx.parentTimer.data.departing)), 1)),
                  _hoisted_3,
                  (_ctx.parentTimer.data.destination === 'store')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        class: "text-primary",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push(`/stores/${_ctx.parentTimer.data.destinationStoreId}`)))
                      }, _toDisplayString(`${_ctx.parentTimer.data.destinationStoreName} #${_ctx.parentTimer.data.destinationStoreNumber}`), 1))
                    : (_openBlock(), _createElementBlock("a", _hoisted_4, _toDisplayString(_ctx.formOptions(_ctx.parentTimer.data.destination)), 1))
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.parentTimer.type === 'store')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                      _createElementVNode("span", {
                        class: "text-primary",
                        href: "#",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push(`/stores/${_ctx.parentTimer.data.store_id}`)))
                      }, _toDisplayString(`${_ctx.parentTimer.data.store_name} #${_ctx.parentTimer.data.store_number}`), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.parentTimer.data?.subtype ? _ctx.formLabel(`options.${_ctx.parentTimer.data?.subtype}`) : null), 1)
                ]),
                _createElementVNode("p", null, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.parentTimer.data.location ? _ctx.formOptions(_ctx.parentTimer.data.location) : undefined), 1)
                ])
              ], 64))
        ])
      ]),
      _: 2
    }, [
      (_ctx.text)
        ? {
            name: "subtitle",
            fn: _withCtx(() => [
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModalEdit()))
              }, _toDisplayString(_ctx.subtitle), 1),
              (_ctx.parentTimer.editable)
                ? (_openBlock(), _createBlock(_component_q_dialog, {
                    key: 0,
                    modelValue: _ctx.modalEdit,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalEdit) = $event)),
                    ref: "editTimerRef"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, { class: "q-pa-md" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_form_header, { type: _ctx.activityType }, null, 8, ["type"]),
                          (_ctx.parentTimer.type === 'travel')
                            ? (_openBlock(), _createBlock(_component_form_travel, {
                                key: 0,
                                edit: "",
                                insert: "",
                                index: _ctx.parentTimer.index!,
                                "insert-times": { start: _ctx.parentTimer.start_time, end: _ctx.parentTimer.end_time },
                                locations: {
              departing: _ctx.parentTimer.data.departing,
              departingStoreName: _ctx.parentTimer.data.departingStoreName,
              departingStoreNumber: _ctx.parentTimer.data.departingStoreNumber,
              destination: _ctx.parentTimer.data.destination,
              destinationStoreName: _ctx.parentTimer.data.destinationStoreName,
              destinationStoreNumber: _ctx.parentTimer.data.destinationStoreNumber,
            },
                                "insert-odo": {
              startOdo: _ctx.parentTimer.data.odometer_start,
              endOdo: _ctx.parentTimer.data.odometer_end,
            },
                                onSaved: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editTimerRef!.hide()))
                              }, null, 8, ["index", "insert-times", "locations", "insert-odo"]))
                            : (_openBlock(), _createBlock(_component_form_parent_activity, {
                                key: 1,
                                index: _ctx.parentTimer.index!,
                                insert: "",
                                editing: "",
                                "end-state": _ctx.endState,
                                "insert-times": { start: _ctx.parentTimer.start_time, end: _ctx.parentTimer.end_time },
                                "insert-data": _ctx.parentTimer.data,
                                "activity-type": _ctx.parentTimer.type,
                                timer: _ctx.parentTimer,
                                onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editTimerRef!.hide()))
                              }, null, 8, ["index", "end-state", "insert-times", "insert-data", "activity-type", "timer"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["title", "color", "icon", "data-unknown", "data-known", "render-index"])
  ], 64))
}